export const getExclusaoRequisicaoExameMessage = (
  hasRequisicaoCitopatologico: boolean,
  hasRequisicaoMamografia: boolean
) => {
  if (hasRequisicaoCitopatologico && hasRequisicaoMamografia) {
    return 'As requisições de exame de mamografia e citopatológico de colo uterino também serão excluídas.'
  }

  if (hasRequisicaoCitopatologico) {
    return 'A requisição de exame de citopatológico de colo uterino também será excluída.'
  }

  if (hasRequisicaoMamografia) {
    return 'A requisição de exame de mamografia também será excluída.'
  }

  return null
}

export const getExclusaoItemRequisicaoExameMessage = (nomeExame: string) =>
  `Ao remover a solicitação de ${nomeExame} todas as informações preenchidas na requisição serão removidas.`
